$(document).ready(function() {
    window.theme = window.theme || {};
    theme.base = {
        collectionLayoutType: 'layout-grid',
        customer: null
    }

    var filter = new Filter();
    filter.initAll();

    var onMobile = $(window).width() < 768;
    var onMobileSm = $(window).width() < 576;

    if ($("a[data-action='scroll-to']").length > 0) {
        $("a[data-action='scroll-to']").each(function (i, obj) {
            $(obj).on("click", function () {
                var target = $(obj).data('target');
                if (!target || target === '')
                    return;

                if ($("#"+target).length === 0)
                    return;

                var scrollTop = $("#"+target).offset().top;
                scrollTop -= 80;

                $('html, body').animate({
                    scrollTop: scrollTop
                }, 600, 'swing');
            })
        })
    }

    $('.qa-section .qa-section-title').on('click', function () {

        var $current_obj = $(this);
        var maxWidth = $(this).data('max');
        if (maxWidth && $(window).width() >= maxWidth) {
            return;
        }

        Array.prototype.forEach.call($('.qa-section .qa-section-title'), function (child) {
            if (child === $current_obj.get(0)) {
                $current_obj.next('.qa-section .qa-section-content').slideToggle(300);
                $current_obj.next('.qa-section .qa-section-content').toggleClass('open');
                $current_obj.toggleClass('open');
            } else {
                if ($(child).hasClass('open')) {
                    $(child).next('.qa-section .qa-section-content').slideToggle(300);
                    $(child).next('.qa-section .qa-section-content').toggleClass('open');
                    $(child).toggleClass('open');
                }
            }
        });
    });

    $(document).on('click', '.accordion-section .accordion-section-title', function(e) {
        var $current_obj = $(this);
        var isMobile = $(this).data('mobile');
        var isDisabled = $(this).data('disabled');

        if (isDisabled)
            return;

        if (isMobile && $(window).width() >= 576)
            return;

        Array.prototype.forEach.call($('.accordion-section .accordion-section-title'), function (child) {
            if (child === $current_obj.get(0)) {
                $current_obj.next('.accordion-section .accordion-section-content').slideToggle(300);
                $current_obj.next('.accordion-section .accordion-section-content').toggleClass('open');
                $current_obj.toggleClass('open');
            } else {
                // Enable to swap the open status
                // if ($(child).hasClass('open')) {
                //   $(child).next('.accordion-section .accordion-section-content').slideToggle(300);
                //   $(child).next('.accordion-section .accordion-section-content').toggleClass('open');
                //   $(child).toggleClass('open');
                // }
            }
        });
    });

    if($(".product-slider").length > 0) {
        $(".product-slider").each(function (i, obj) {
            var isInfinite = $(obj).data('slide-infinite');
            var slidesToShow = $(obj).data('slides-to-show');
            var sliderLayout = $(obj).data('slider-layout');
            var centerMode = $(obj).data('center-mode');
            var collectionSection = $(obj).data('collection-section');
            var disableOnMobile = $(obj).data('disable-on-mobile');
            
            if (disableOnMobile && onMobileSm) {
                return;
            }

            if ($(obj).hasClass('product-slider-grid')) {
                $(obj).slick({
                    autoplay: false,
                    infinite: isInfinite,
                    dots: true,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToScroll: 1,
                                slidesToShow: 1,
                                dots: true,
                                arrows: false
                            }
                        }
                    ]
                });
            } else {
                $(obj).slick({
                    autoplay: false,
                    infinite: false,
                    dots: true,
                    arrows: true,
                    appendArrows: $(obj).closest('.section-slider').find(".jw-slider-arrows"),
                    slidesToShow: slidesToShow,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                infinite: isInfinite,
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                dots: true,
                                arrows: false
                            }
                        },
                        {
                            breakpoint: 576,
                            settings: {
                                infinite: isInfinite,
                                slidesToShow: (collectionSection || sliderLayout === 'single') ? 1 : 2,
                                slidesToScroll: 1,
                                // centerMode: centerMode,
                                // centerPadding: '12px',
                                dots: true,
                                arrows: false
                            }
                        }
                    ]
                });
            }
        });
    }

    if ($(".beta-launch-slider").length > 0) {
        var bt_slider = $(".beta-launch-slider").slick({
            autoplay: false,
            infinite: false,
            dots: false,
            arrows: true,
            appendArrows: $(".beta-launch-banner .slider-navigator .slider-arrows"),
            slidesToShow: 1,
            slidesToScroll: 1
        });

        bt_slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            var sliderIndex = nextSlide + 1;
            sliderIndex = ('0' + sliderIndex).slice(-2);
            $('.beta-launch-banner .slider-navigator .current-page').text(sliderIndex);
        });
    }

    if ($(".value-slider").length > 0) {
        var thumbSize = $(".value-slider").data('thumb-size');
        var valueSwiper = new Swiper(".value-slider", {
            slidesPerView: thumbSize === 'large' ? 1 : 4,
            initialSlide: 0,
            spaceBetween: thumbSize === 'large' ? 64 : 32,
            speed: 600,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    initialSlide: 2,
                },
                992: {
                    slidesPerView: thumbSize === 'large' ? 1 : 2,
                    spaceBetween: 16,
                    initialSlide: 1,
                },
                1440: {
                    slidesPerView: thumbSize === 'large' ? 1 : 3,
                    spaceBetween: 32,
                    initialSlide: 0,
                },
            }
        });
    }

    if ($(".ambassadors-banner-v2 .banner-slider").length > 0) {
        $(".ambassadors-banner-v2 .banner-slider").slick({
            autoplay: false,
            infinite: false,
            dots: false,
            arrows: true,
            appendArrows: $(".ambassadors-banner-v2 .banner-slider-arrows"),
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }

    if ($(".ambassadors-pros .pros-slider").length > 0) {
        var prosSwiper = new Swiper(".ambassadors-pros .pros-slider", {
            slidesPerView: 3,
            initialSlide: 0,
            spaceBetween: 32,
            speed: 600,
            loop: true,
            calculateHeight:true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    initialSlide: 0,
                },
                1200: {
                    slidesPerView: 2,
                    spaceBetween: 32,
                    initialSlide: 0,
                },
            }
        });
    }
    
    if ($(".pros-slider .js-read-more").length > 0) {
        $(document).on('click', '.pros-slider .js-read-more', function () {
            var scrollTop0 = $(window).scrollTop();
            var $reviewWrapper = $(this).closest('.jw-review');
            $reviewWrapper.addClass('open-full-review');
            window.scrollTo(0,scrollTop0);
        })
    }

    if ($(".pros-slider .js-read-less").length > 0) {
        $(document).on('click', '.pros-slider .js-read-less', function () {
            var $reviewWrapper = $(this).closest('.jw-review');
            $reviewWrapper.removeClass('open-full-review');
            document.getElementById('ambassadors-pros').scrollIntoView();
        })
    }

    $(".collection-filter input[name='swap-collection-layout']").click(function (e) {
        var layoutType = $("input[name='swap-collection-layout']:checked").val();

        if (theme.base.collectionLayoutType !== layoutType) {
            theme.base.collectionLayoutType = layoutType;
            if (layoutType === 'layout-single')
                $("#CollectionSection").removeClass('grid-column').addClass('grid-single');
            else
                $("#CollectionSection").removeClass('grid-single').addClass('grid-column');
        }
    });

    $(".search-suggestion").on('click', function () {
        var query = $(this).data('suggestion');
        document.getElementById("search-query").value = query;
        document.getElementById("search-form").submit();
    });

    // var prevScrollpos = window.pageYOffset;
    // window.onscroll = function() {
    //     if (onMobile)
    //         return;
    //
    //     var currentScrollPos = window.pageYOffset;
    //     if (prevScrollpos > currentScrollPos) {
    //         document.getElementById("navbar").style.top = "0";
    //     } else {
    //         document.getElementById("navbar").style.top = "-120px";
    //     }
    //     prevScrollpos = currentScrollPos;
    // }

    if ($(".video-wrapper").length > 0) {
        $('.video-wrapper .btn-play-video').unbind('click').bind('click', function (e) {
            e.preventDefault();
            var $parent = $(this).closest('.video-wrapper');
            var video = $parent.find('video')[0];
            if (!video)
                return;
            var isPlaying = $(video).data('is-playing');
            if (!isPlaying) {
                video.play();
                $(video).data('is-playing', true);
                $(this).addClass('disabled');
            } else {
                video.pause();
                $(video).data('is-playing', false);
            }
        });
    }

    if ($('#CollectionSection').length > 0) {
        $(document).on('click', '.js-drawer-toggle-filter', function () {
            var isOpen = $(this).hasClass('open');
            var $CollectionFilter = $('#CollectionFilter');
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                $CollectionFilter.addClass('hide');
            } else {
                $(this).addClass('open');
                $CollectionFilter.removeClass('hide');
            }

            Array.prototype.forEach.call($('#CollectionAjaxResult .jw-col'), function (product) {
                if (isOpen) {
                    $(product).addClass('col-lg-3')
                } else {
                    $(product).removeClass('col-lg-3')
                }
            });
        })
    }

    // Scroll to Top
    $('#scroll-to-top a').click(function() {
        window.scrollTo(0,0);
        return false;
    });

    // Mega Menu Setting
    var $navSubMenu = $(".main-menu-v2 .sub-menu");
    if ($navSubMenu.length > 0) {
        $navSubMenu.hover(
            function() {
                var $parentNav = $(this).parent().closest('li').find('.nav-head');
                if (!$parentNav.hasClass('hover')) {
                    $parentNav.addClass('hover');
                }
            }, function() {
                var $parentNav = $(this).parent().closest('li').find('.nav-head');
                if ($parentNav.hasClass('hover')) {
                    $parentNav.removeClass('hover');
                }
                if ($(this).hasClass('hover-effect')) {
                    $(this).removeClass('hover-effect');
                }
                if ($('#navbar').hasClass('sub-menu-open')) {
                    $('#navbar').removeClass('sub-menu-open');
                }
            }
        );
    }

    var $navHead = $(".main-menu-v2 .nav-head");
    if ($navHead.length > 0) {
        $navHead.hover(
            function() {
                if ($(this).hasClass('no-child'))
                    return;
                $navHead.removeClass('hover');
                $(this).addClass('hover');
                $('#navbar').addClass('sub-menu-open');
                if (!$(this).next('.sub-menu').hasClass('hover-effect')) {
                    $(this).next('.sub-menu').addClass('hover-effect');
                }
            }, function() {
                setTimeout(() => {
                    if ($(this).hasClass('hover') && !$(this).next('.sub-menu').hasClass('hover-effect')) {
                        $(this).removeClass('hover');
                    }
                }, 1000);
            }
        );
    }

    $('#MainContent form').submit(function(event) {
        var hasError = false;
        Array.prototype.forEach.call($(this).find('.cart__product-qty'), function (item) {
            var key = $(item).data('product-key');
            var quantity = Number($(item).val());
            var min = $(item).data('min');
            var max = $(item).data('max');
            var isBulk = $(item).data('bulk');
            var $error = $(item).closest('.jw-quantity').find('.cp-correction');
            var interval = 10;
            var variantId = $(item).data('variant-id');

            var message = {
                invalid_quantity: 'Invalid amount.',
                out_of_stock: 'Only ' + max + ' amount in stock.',
                need_bulk: 'Sold in multiples of 10',
                need_bulk_of_2: 'Sold in multiples of 2',
            }

           if (variantId === 40982200647791 ||
                    variantId === 40982200680559 ||
                    variantId === 40982200713327 ||
                    variantId === 40982200746095 ||
                    variantId === 40982200778863 ||
                    variantId === 40982200811631 ||
                    variantId === 40982200844399 ||
                    variantId === 40982200877167 ||
                    variantId === 40982201401455 ||
                    variantId === 40982201434223 ||
                    variantId === 40982201466991 ||
                    variantId === 40982201499759 ||
                    variantId === 40982201532527 ||
                    variantId === 40982201565295 ||
                    variantId === 40982201598063 ||
                    variantId === 40982201630831 ||
                    variantId === 40982201663599 ||
                    variantId === 40982201696367 ||
                    variantId === 40982201729135 ||
                    variantId === 40982184820847 ||
                    variantId === 40982184853615 ||
                    variantId === 40982184886383 ||
                    variantId === 40982184919151 ||
                    variantId === 40982184951919 ||
                    variantId === 40982184984687 ||
                    variantId === 40982185017455 ||
                    variantId === 40982185050223 ||
                    variantId === 41055654740079 ||
                    variantId === 41055654772847 ||
                    variantId == 41094274351215 ||
                    variantId == 41094274383983 ||
                    variantId == 41094274416751 ||
                    variantId == 41094274449519 ||
                    variantId === 41055654707311 ||
                    variantId === 41112058134639 ||
                    variantId === 41224867053679 ||
                    variantId === 41224867184751 ||
                    variantId === 41224867479663 ||
                    variantId === 41224867545199 ||
                    variantId == 41550730559599 ||
                     variantId == 42039124918383 ||
                     variantId == 42039124951151 ||
                     variantId == 42039124983919 ||
                     variantId == 42039125016687                   
              ) {
                  interval = 2;
                } else if (variantId === 40982200615023 ||
                           variantId === 40982183346287 ||
                           variantId === 51618205008244 ||
                           variantId === 51618205041012 ||
                           variantId === 51618205073780 ||
                           variantId === 51618199929204 ||
                           variantId === 51618199961972 ||
                           variantId === 51618199994740
                          ) {
                  interval = 5; 
                }

              if (quantity <= 0) {
                      $(item).addClass('error');
                      $error.html(message.invalid_quantity);
                      hasError = true;
                    } else if (quantity < min || quantity > max) {
                        $(item).addClass('error');
                        $error.html(message.out_of_stock);
                        hasError = true;
                    } else if (isBulk && quantity % interval !== 0 ) {
                        $(item).addClass('error');
                        $error.html(interval === 10 ? message.need_bulk : message.need_bulk_of_2);
                        hasError = true;
                    } else {
                        $(item).removeClass('error');
                        $error.html("");
                    }
                });
          
                if (hasError) {
                    event.preventDefault();
                    $(this).find("button[type='submit']").removeClass('btn--loading');
                }
            });

    var header = $(".header");
    var className = ''
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll < 80) {
            className = 'position-top'
        } else if (scroll > 240) {
            className = 'position-bottom'
        } else {
            className = 'position-mid'
        }

        var $homebanner = $('.jw-home-banner');
        if (!$homebanner.hasClass(className)) {
            var defaultClass = $homebanner.data('default-class');
            $homebanner.removeClass().addClass(defaultClass).addClass(className);
        }

    });

    if ($('#ambassadors-form').length > 0) {
        var ambassadorForm = $('#ambassadors-form');
        var $btnSubmit = $(ambassadorForm).find('.btn-submit');
        var ambassadorFormLoading = false;

        var validateOpts = {
            mergeAlerts: true,
            alertTarget: $('#ambassadors-form .default-notification'),
            alertMessage: 'Sorry, there was a problem! Please check the errors and try again.',
            fields: {
                'contact[fullName]': {
                    required: {
                        helpText: "Please enter your name"
                    }
                },
                'contact[instagramName]': {
                    required: {
                        helpText: "Please enter your @instagram name"
                    }
                },
                'contact[email]': {
                    required: {
                        helpText: "Please enter your email"
                    },
                    email: {
                        helpText: "Please enter your email"
                    }
                },
                'contact[Why our Beta]': {
                    required: {
                        helpText: "Please let us know your idea"
                    }
                }
            },
            formGroupSelector: '.jw-form-group',
            toggleHelpTextOnSubmit: true,
            autoScrollToAlerts: false,
            success: function (event) {

                event.preventDefault();

                if (ambassadorFormLoading)
                    return;

                var name = $(ambassadorForm).find("input[id^='FullName-']").val();
                var email = $(ambassadorForm).find("input[id^='Email-']").val();
                var instagram = $(ambassadorForm).find("input[id^='InstagramName-']").val();
                var resource = $(ambassadorForm).find("select[id^='ContactSource-']").val();
                var message = $(ambassadorForm).find("textarea[id^='contact[Why our Beta]']").val();

                $btnSubmit.addClass('btn--loading');

                $.ajax({
                    url        : theme.settings.apiBase + "/ambassador",
                    method     : "POST",
                    dataType   : "json",
                    contentType: "application/json",
                    cache      : false,
                    data       : JSON.stringify({
                        full_name: name,
                        email: email,
                        instagram: instagram,
                        resource: resource,
                        message: message
                    }),
                    beforeSend : function (xhr) {
                        $btnSubmit.addClass('btn--loading');
                        ambassadorFormLoading = true;
                    }
                }).done((data) => {
                    $btnSubmit.removeClass('btn--loading');
                    window.location = "/pages/thanks-for-applying";
                    ambassadorFormLoading = false;
                }).fail((error) => {
                    $btnSubmit.removeClass('btn--loading');
                    window.location = "/pages/thanks-for-applying";
                    ambassadorFormLoading = false;
                    console.log(error);
                });
            }
        };

        $(ambassadorForm).bsValidate(validateOpts);
    }

    if ($('#register-form').length > 0) {
        var registerForm = $('#register-form');
        var $registerBtnSubmit = $(registerForm).find('.btn-submit');
        var registerFormLoading = false;

        $(registerForm).submit(function(event) {

            event.preventDefault();

            if (registerFormLoading)
                return;

            var firstName = $(registerForm).find("input[id='RegisterFirstName']").val();
            var lastName = $(registerForm).find("input[id='RegisterLastName']").val();
            var email = $(registerForm).find("input[id='RegisterEmail']").val();
            var instagram = $(registerForm).find("input[id='RegisterInstagram']").val();
            var shopName = $(registerForm).find("input[id='ShopName']").val();
            var shopAddress = $(registerForm).find("input[id='ShopAddress']").val();
            var shopCity = $(registerForm).find("input[id='ShopCityName']").val();
            var shopProvince = $(registerForm).find("select[id='AddressProvinceNew']").val();
            var shopPostalCode = $(registerForm).find("input[id='ShopPostalCode']").val();
            var shopCountry = $(registerForm).find("select[id='AddressCountryNew']").val();
            var shopPhone = $(registerForm).find("input[id='RegisterPhone']").val();
            var shopEmail = $(registerForm).find("input[id='ShopEmail']").val();
            var shopWebsite = $(registerForm).find("input[id='ShopWebsite']").val();
            var shopInstagram = $(registerForm).find("input[id='ShopInstagram']").val();
            var subscribeNewsletter = $(registerForm).find("input[id='ShopNewsletter']").val();

            $.ajax({
                url        : theme.settings.apiBase + "/account",
                method     : "POST",
                dataType   : "json",
                contentType: "application/json",
                cache      : false,
                data       : JSON.stringify({
                    first_name        :     firstName,
                    last_name         :     lastName,
                    email             :     email,
                    instagram         :     instagram,
                    shop_name         :     shopName,
                    shop_address      :     shopAddress,
                    shop_city         :     shopCity,
                    shop_province     :     shopProvince,
                    shop_postal_code  :     shopPostalCode,
                    shop_country      :     shopCountry,
                    shop_phone        :     shopPhone,
                    shop_email        :     shopEmail,
                    shop_website      :     shopWebsite,
                    shop_instagram    :     shopInstagram,
                    subscribe_newsletter  : subscribeNewsletter
                }),
                beforeSend : function (xhr) {
                    $registerBtnSubmit.addClass('btn--loading');
                    registerFormLoading = true;
                }
            }).done((data) => {
                $registerBtnSubmit.removeClass('btn--loading');
                registerFormLoading = false;
                window.location = "/pages/thanks-register";
            }).fail((error) => {
                $registerBtnSubmit.removeClass('btn--loading');
                registerFormLoading = false;
                window.location = "/pages/thanks-register";
                console.log(error);
            });
        })
    }

    if ($('#CustomerUpdateForm').length > 0) {
        var customerUpdateForm = $('#CustomerUpdateForm');
        var $dataDiv = $('#CustomerUpdateForm .customer-info');
        var $updateBtnSubmit = $(customerUpdateForm).find('.btn-submit');
        var $formNotification = $(customerUpdateForm).find('.form-notification');
        var updateFormLoading = false;

        $(customerUpdateForm).submit(function(event) {

            event.preventDefault();

            if (updateFormLoading)
                return;

            var firstName = $(customerUpdateForm).find("input[id='UpdateFirstName']").val();
            var lastName = $(customerUpdateForm).find("input[id='UpdateLastName']").val();
            var email = $(customerUpdateForm).find("input[id='UpdateEmail']").val();
            var instagram = $(customerUpdateForm).find("input[id='UpdateInstagram']").val();
            var shopName = $(customerUpdateForm).find("input[id='ShopName']").val();
            var shopAddress = $(customerUpdateForm).find("input[id='ShopAddress']").val();
            var shopCity = $(customerUpdateForm).find("input[id='ShopCityName']").val();
            var shopProvince = $(customerUpdateForm).find("select[id='AddressProvinceNew']").val();
            var shopPostalCode = $(customerUpdateForm).find("input[id='ShopPostalCode']").val();
            var shopCountry = $(customerUpdateForm).find("select[id='AddressCountryNew']").val();
            var shopPhone = $(customerUpdateForm).find("input[id='UpdatePhone']").val();
            var shopEmail = $(customerUpdateForm).find("input[id='ShopEmail']").val();
            var shopWebsite = $(customerUpdateForm).find("input[id='ShopWebsite']").val();
            var shopInstagram = $(customerUpdateForm).find("input[id='ShopInstagram']").val();
            var customerId = $dataDiv.data('customer-id');

            $.ajax({
                url        : theme.settings.apiBase + "/account/update",
                method     : "POST",
                dataType   : "json",
                contentType: "application/json",
                cache      : false,
                data       : JSON.stringify({
                    first_name        :     firstName,
                    last_name         :     lastName,
                    email             :     email,
                    instagram         :     instagram,
                    shop_name         :     shopName,
                    shop_address      :     shopAddress,
                    shop_city         :     shopCity,
                    shop_province     :     shopProvince,
                    shop_postal_code  :     shopPostalCode,
                    shop_country      :     shopCountry,
                    shop_phone        :     shopPhone,
                    shop_email        :     shopEmail,
                    shop_website      :     shopWebsite,
                    shop_instagram    :     shopInstagram,
                    customer_id       :     customerId
                }),
                beforeSend : function (xhr) {
                    $updateBtnSubmit.addClass('btn--loading');
                    $formNotification.addClass('d-none');
                    $formNotification.find('.cp-note--success').addClass('d-none');
                    $formNotification.find('.cp-note--error').addClass('d-none');
                    updateFormLoading = true;
                }
            }).done((data) => {
                updateFormLoading = false;
                window.location = "/account?view=edit";
            }).fail((error) => {
                $updateBtnSubmit.removeClass('btn--loading');
                $formNotification.removeClass('d-none');
                $formNotification.find('.cp-note--error').removeClass('d-none');
                updateFormLoading = false;
                console.log(error);
            });
        })

        $("#CustomerUpdateForm .form-notification .js-close-notification").on('click', function () {
            $("#CustomerUpdateForm .form-notification").addClass('d-none');
        });
    }

    if ($('#contact-beta').length > 0) {
        var contactBeta = $('#contact-beta');
        var $contactBetaBtnSubmit = $(contactBeta).find('.btn-submit');
        var $contactError = $(contactBeta).find('.signup-form-error-text');
        var contactBetaLoading = false;
      	var codeOfConductChecked = $('#Agree-Code-Conduct').is(':checked');
      
      
      	//check if they agreed to the code of conduct
        if (!codeOfConductChecked) $contactError.html("Please agree to Junipurr's Code of Conduct to proceed.");
        $('#Agree-Code-Conduct').click(function(e){
          if (e.target.checked) {
          	$contactError.html("");
          } else {
            $contactError.html("Please agree to Junipurr's Code of Conduct to proceed.");
          }
        })

        $(contactBeta).submit(function(event) {

            event.preventDefault();
          
			
            if (contactBetaLoading)
                return;

            var firstName = $(contactBeta).find("input[id='ContactFormFirstName']").val();
            var lastName = $(contactBeta).find("input[id='ContactFormLastName']").val();
            var email = $(contactBeta).find("input[id='ContactFormEmail']").val();
            var portfolio = $(contactBeta).find("input[id='ContactFormPortfolioLink']").val();
            var address = $(contactBeta).find("input[id='ContactFormAddress']").val();
            var studioName = $(contactBeta).find("input[id='ContactFormBusinessName']").val();
          	var ownerYes = $(contactBeta).find("input[id='Owner-Yes']").is(':checked');
          	var studioInfo = $(contactBeta).find("input[id='ContactFormStudioInfo']").val();
            var website = $(contactBeta).find("input[id='ContactFormStudioWebsite']").val();
            var resource = $(contactBeta).find("input[id='ContactFormResource']").val();
            var promoCode = $(contactBeta).find("input[id='ContactFormReferralCode']").val();
            var years_experience = $(contactBeta).find("input[id='ContactFormYears']").val();
          
          console.log("studio name", studioName);

            var reasons = '';
            var $reasons = $(contactBeta).find(".jw-form-why-junipurr input[type=checkbox]");
            for (var i = 0; i < $reasons.length; i ++) {
                if (!$($reasons[i]).prop('checked') && !$($reasons[i]).data('other'))
                    continue;

                var reason = $($reasons[i]).data('reason');
                if ($($reasons[i]).data('other')) {
                    reason = $(contactBeta).find("input[name='contact[other]']").val();
                }

                reasons += reason;
                if (i < $reasons.length - 1) reasons += '\n'
            }

            $.ajax({
                url        : theme.settings.apiBase + "/beta-user",
                method     : "POST",
                dataType   : "json",
                contentType: "application/json",
                cache      : false,
                data       : JSON.stringify({
                    first_name        :     firstName,
                    last_name         :     lastName,
                    business_name     :     studioName,
                    address			  :		address,
                    email             :     email,
                    years_experience  :     years_experience,
                    portfolio         :     portfolio,
                  	owner			  :		ownerYes,
                  	studio_info		  :     studioInfo,
                    website           :     website,
                    join_reason       :     reasons,
                    resource          :     resource,
                    promo_code        :     promoCode,
                }),
                beforeSend : function (xhr) {
                    $contactBetaBtnSubmit.addClass('btn--loading');
                    contactBetaLoading = true;
                }
            }).done((data) => {
                $contactBetaBtnSubmit.removeClass('btn--loading');
                window.location = "/pages/thanks-register";
                contactBetaLoading = false;
            }).fail((xhr, status, error) => {
                $contactError.html(xhr.responseJSON.message);
                $contactBetaBtnSubmit.removeClass('btn--loading');
                contactBetaLoading = false;
            });
        })
    }

    if ($('#contact-beta2').length > 0) {
        var contactBeta2 = $('#contact-beta2');
        var $contactBetaBtnSubmit2 = $(contactBeta2).find('.btn-submit');
        var contactBeta2Loading = false;

        $(contactBeta2).submit(function(event) {

            event.preventDefault();

            if (contactBeta2Loading)
                return;

            var firstName = $(contactBeta2).find("input[id='ContactFormBottomFirstName']").val();
            var lastName = $(contactBeta2).find("input[id='ContactFormBottomLastName']").val();
            var businessName = $(contactBeta).find("input[id='ContactFormBusinessName']").val();
            var email = $(contactBeta2).find("input[id='ContactFormBottomEmail']").val();
            var instagram = $(contactBeta2).find("input[id='ContactFormBottomPortfolioLink']").val();
            var promoCode = $(contactBeta2).find("input[id='ContactFormReferralCode']").val();

            $.ajax({
                url        : theme.settings.apiBase + "/beta-user",
                method     : "POST",
                dataType   : "json",
                contentType: "application/json",
                cache      : false,
                data       : JSON.stringify({
                    first_name        :     firstName,
                    last_name         :     lastName,
                    business_name     :     businessName,
                    email             :     email,
                    instagram         :     instagram,
                    promo_code        :     promoCode,
                }),
                beforeSend : function (xhr) {
                    $contactBetaBtnSubmit2.addClass('btn--loading');
                    contactBeta2Loading = true;
                }
            }).done((data) => {
                $contactBetaBtnSubmit2.removeClass('btn--loading');
                $(contactBeta2).unbind('submit').submit();
                contactBeta2Loading = false;
            }).fail((error) => {
                $contactBetaBtnSubmit2.removeClass('btn--loading');
                $(contactBeta2).unbind('submit').submit();
                contactBeta2Loading = false;
                console.log(error);
            });
        })
    }

    if ($('#newsletter-sign-up__footer').length > 0) {
        var footerNewsletterForm = $('#newsletter-sign-up__footer');
        var $btnNewsletterSubmit = $(footerNewsletterForm).find('.btn-submit');
        var $inputGroup = $(footerNewsletterForm).find('.newsletter__input-group');
        var $noteSuccess = $(footerNewsletterForm).find('.note--success');
        var $noteError = $(footerNewsletterForm).find('.errors');
        var isNewsletterSubscribing = false;

        $(footerNewsletterForm).submit(function(event) {
            event.preventDefault();

            if (isNewsletterSubscribing)
                return;

            var email = $(footerNewsletterForm).find("input[type=email]").val();

            isNewsletterSubscribing = true;
            $btnNewsletterSubmit.addClass('btn--loading');

            $.ajax({
                url        : theme.settings.apiBase + "/newsletter",
                method     : "POST",
                dataType   : "json",
                contentType: "application/json",
                cache      : false,
                data       : JSON.stringify({
                    email             :     email,
                }),
                beforeSend : function (xhr) {
                    $btnNewsletterSubmit.addClass('btn--loading');
                }
            }).done((data) => {
                $btnNewsletterSubmit.removeClass('btn--loading');
                $inputGroup.remove();
                $noteSuccess.removeClass('d-none');
                isNewsletterSubscribing = false;
            }).fail((error) => {
                $btnNewsletterSubmit.removeClass('btn--loading');
                $inputGroup.remove();
                isNewsletterSubscribing = false;
                if (error.status === 400) {
                    $noteSuccess.removeClass('d-none');
                } else {
                    $noteError.removeClass('d-none');
                    console.log(error);
                }
            });
        })
    }

    if ($('#newsletter-newsletter-popup').length > 0) {
        var popupNewsletterForm = $('#newsletter-newsletter-popup');
        var $btnPopupSubmit = $(popupNewsletterForm).find('.btn-submit');
        var $popupInputGroup = $(popupNewsletterForm).find('.newsletter__input-group, .cp-label');
        var $popupNoteSuccess = $(popupNewsletterForm).find('.note-success');
        var $popupNoteError = $(popupNewsletterForm).find('.note-errors');
        var isPopupNewsletterSubscribing = false;
        
        $(popupNewsletterForm).submit(function(event) {
            event.preventDefault();
            
            if (isPopupNewsletterSubscribing)
                return;

            var email = $(popupNewsletterForm).find("input[type=email]").val();

            isPopupNewsletterSubscribing = true;
            $btnPopupSubmit.addClass('btn--loading');

            $.ajax({
                url        : theme.settings.apiBase + "/newsletter",
                method     : "POST",
                dataType   : "json",
                contentType: "application/json",
                cache      : false,
                data       : JSON.stringify({
                    email             :     email,
                }),
                beforeSend : function (xhr) {
                    $btnPopupSubmit.addClass('btn--loading');
                }
            }).done((data) => {
                $btnPopupSubmit.removeClass('btn--loading');
                $popupInputGroup.remove();
                $popupNoteSuccess.removeClass('d-none');
                isNewsletterSubscribing = false;
                $('body').trigger('closeNewsletterPopup');
            }).fail((error) => {
                $btnPopupSubmit.removeClass('btn--loading');
                $popupInputGroup.remove();
                isNewsletterSubscribing = false;
                if (error.status === 400) {
                    $popupNoteSuccess.removeClass('d-none');
                    $('body').trigger('closeNewsletterPopup');
                } else {
                    $popupNoteError.removeClass('d-none');
                    console.log(error);
                }
            });
        })
    }

    if( $('.jw-product-item-swatch').length > 0 ) {
        Array.prototype.forEach.call($('.jw-product-item-swatch'), function (item) {
            new theme.Swatch($(item));
        });
    }

    if( $('.thumb-loads').length > 0 ) {
        Array.prototype.forEach.call($('.thumb-loads'), function (item) {
            new theme.ThumbLoads($(item));
        });
    }

    $(".jw-form-message input[type='radio']").click(function (e) {
        var $parent = $(this).closest('.jw-form-message');
        var subject = $("input[type='radio']:checked", $parent).val();
        var $otherReason = $parent.find('.contact-form-other');

        if (subject === 'Other') {
            $otherReason.removeClass('d-none')
        } else {
            $otherReason.addClass('d-none');
        }
    });

    $(".jw-form-why-junipurr input[type='checkbox']").click(function (e) {
        var $parent = $('.jw-form-why-junipurr');
        var $target = $(e.target);
        var $reason = $parent.find('.other-reason');

        if (!$target.data('other'))
            return;

        // disable this functionality
        return;

        if ($target.prop('checked')) {
            $reason.removeClass('d-none')
        } else {
            $reason.addClass('d-none')
        }
    });
    
    if ($('#ContactFormAddress').length > 0) {
      new AddressAutocomplete('#ContactFormAddress', function (result) {
        console.log(result);
      });
    }

    if ($('#ShopAddress').length > 0) {
      new AddressAutocomplete('#ShopAddress', function (result) {
        console.log(result);
      });
    }

    new Swiper('.homepage-v3 .collection .collection-slider.swiper-container', {
      slidesPerView: 2,
      centeredSlides: false,
      grabCursor: true,
      spaceBetween: 32,
      breakpoints: {
        768: {
          spaceBetween: 24,
          slidesPerView: 1,
        },
      },
      navigation: {
        nextEl: '.homepage-v3 .collection .collection-slider .swiper-button-next',
        prevEl: '.homepage-v3 .collection .collection-slider .swiper-button-prev'
      },
      pagination: {
        el: '.homepage-v3 .collection .collection-slider .swiper-pagination',
        clickable: true,
        count: 3
      },
    });
});